export default "__VITE_ASSET__Djj1NMB1__"